<template>
  <div class="field field pr-4">
    <FieldLabel :field="field" />
    <ErrorMessage
      v-if="errors"
      :error="errorMessage"
    />
    <div v-show="initialState">
      <div>
        <div
          v-if="!disconnectFile"
          class="flex justify-start items-center text-xs"
        >
          <img
            class="rounded mr-2"
            alt=""
            src="/images/document-types/document.png"
            style="height: 24px"
          >
          <div>
            <a
              :href="downloadLink"
              class="btn btn--link"
              v-text="'Download'"
            />
            <span v-if="!isDisabled">
              or
              <button
                type="button"
                class="btn btn--link"
                @click.prevent="remove"
                v-text="'remove'"
              />
            </span>
          </div>
        </div>
        <div
          v-else
          class="text-xs text-red italic"
          v-text="'File will be disconnected when this form is saved.'"
        />
      </div>
    </div>
    <BaseDropzone
      v-show="! initialState && !isDisabled"
      :inline-previews="true"
      :options="dropzoneOptions"
      @dropzone-file-added="filesHaveBeenAdded"
      @dropzone-queue-complete="uploadHasCompleted"
      @dropzone-removed-file="fileHasBeenRemoved"
      @dropzone-success="fileHasBeenUploaded"
    />
    <HelpText
      v-if="field.attributes.help && !fileExists"
      :help-text="field.attributes.help"
      style="top: -10px"
    />
  </div>
</template>

<script type="text/babel">
import HelpText from './HelpText'
import FieldLabel from './FieldLabel'
import ErrorMessage from './ErrorMessage'
import InputField from 'FormBuilder/Resources/assets/js/mixins/input-field.js'

export default {
  name: 'FileField',
  components: {
    FieldLabel,
    ErrorMessage,
    HelpText,
  },
  mixins: [InputField],
  data() {
    return {
      disconnectFile: false,
      isUploading: false,
      dropzoneOptions: {
        maxFiles: 1,
        dictDefaultMessage: 'Drop File or Click to Upload',
        acceptedFiles: this.field.attributes.type === 'image' ? 'image/*' : null,
        url: this.buildUploadUrl,
      },
      value: '',
    }
  },
  computed: {
    fileExists() {
      return Boolean(this.initialState) || Boolean(this.value)
    },
    downloadLink() {
      if (this.formLocation === 'profile') {
        return this.$urlGenerator.forUnion(this.unionSlug) + `documents/${this.value}/download`
      }

      return `/documents/${this.value}/download`
    },
  },
  async mounted() {
    await this.$nextTick()

    if (this.initialState) {
      this.value = this.initialState
    }
  },
  methods: {
    uploadHasCompleted() {
      this.isUploading = false

      this.$emit('uploadHasCompleted')
    },
    fileHasBeenRemoved(file) {
      this.value = null
    },
    fileHasBeenUploaded(file, uuid) {
      this.value = uuid
    },
    filesHaveBeenAdded() {
      this.isUploading = true

      this.$emit('filesHaveBeenAdded')
    },
    remove() {
      if (confirm('Are you sure you want to disconnect this file?')) {
        this.value = null
        this.disconnectFile = true
      } else {
        this.disconnectFile = false
      }
    },
    buildUploadUrl() {
      switch (this.formLocation) {
        case 'profile':
          return this.$urlGenerator.public(`api/v1/unions/${this.unionSlug}/documents/upload`)
        case 'request-access':
          return this.$urlGenerator.active(`api/v1/membership/access-requests/documents/upload`)
        default:
          return this.$urlGenerator.active('api/v1/forms/upload')
      }
    },

  },
}
</script>
